import { Icon } from '@chakra-ui/icons'
import React, { useState } from 'react'
import { FaPlus } from 'react-icons/fa6'
import IconButtonWithTooltip from '~components/shared/icon-button-with-tooltip'
import { useTeamChatAttachments } from './provider'

export default function TeamChatInputAttachmentsButton() {
    const { openFileSelector, isProcessing } = useTeamChatAttachments()

    return (
        <IconButtonWithTooltip
            label="Add attachment"
            size="sm"
            rounded="full"
            variant="subtle"
            bg="gray.200"
            _hover={{
                bg: 'gray.300',
            }}
            tooltipOverrides={{
                placement: 'top',
            }}
            icon={<Icon as={FaPlus} />}
            onClick={openFileSelector}
            isLoading={isProcessing}
        />
    )
}
